var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-creator-fixed-button"},[_c('img',{style:(_vm.style),attrs:{"src":_vm.value.image}})])}
var staticRenderFns = []

export { render, staticRenderFns }